export type B2ServiceResponseDifferenceKind = 'ArrayLength' | 'MissingProperty' | 'Type' | 'Value';

export type B2ServiceResponseComparison =
    | {
          isMatch: true;
      }
    | {
          isMatch: false;
          differenceKind: B2ServiceResponseDifferenceKind;
      };

export function compareB2ServiceResponses(
    owaResponse: unknown,
    b2ServiceResponse: unknown
): B2ServiceResponseComparison {
    const differenceKind = findDifference(owaResponse, b2ServiceResponse);
    return differenceKind ? { isMatch: false, differenceKind } : { isMatch: true };
}

function findDifference(
    owaValue: unknown,
    b2ServiceValue: unknown
): B2ServiceResponseDifferenceKind | undefined {
    if (Object.is(owaValue, b2ServiceValue)) {
        return undefined;
    }

    if (owaValue === null || b2ServiceValue === null || typeof owaValue !== typeof b2ServiceValue) {
        return 'Type';
    }

    if (typeof owaValue !== 'object' || typeof b2ServiceValue !== 'object') {
        return 'Value';
    }

    const owaIsArray = Array.isArray(owaValue);
    const b2ServiceIsArray = Array.isArray(b2ServiceValue);
    if (owaIsArray !== b2ServiceIsArray) {
        return 'Type';
    }

    if (owaIsArray && b2ServiceIsArray) {
        if (owaValue.length !== b2ServiceValue.length) {
            return 'ArrayLength';
        }

        for (let index = 0; index < owaValue.length; index++) {
            const differenceKind = findDifference(owaValue[index], b2ServiceValue[index]);
            if (differenceKind) {
                return differenceKind;
            }
        }
        return undefined;
    }

    const owaObject = owaValue as Record<string, unknown>;
    const b2ServiceObject = b2ServiceValue as Record<string, unknown>;
    const owaKeys = Object.keys(owaObject);
    const b2ServiceKeys = Object.keys(b2ServiceObject);
    if (owaKeys.length !== b2ServiceKeys.length) {
        return 'MissingProperty';
    }

    for (const key of owaKeys) {
        if (!Object.prototype.hasOwnProperty.call(b2ServiceObject, key)) {
            return 'MissingProperty';
        }

        const differenceKind = findDifference(owaObject[key], b2ServiceObject[key]);
        if (differenceKind) {
            return differenceKind;
        }
    }

    return undefined;
}
